<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else class="col_12">
      <div class="d_flex_btwn">
        <h1 class="common_title">
          <span v-if="$route.params.id">Edit License</span>
          <span v-else>Create a New License</span>
        </h1>
        <span>
          <router-link :to="{ name: 'licenses' }" class="btn btn_black"
            >Back to List</router-link
          >
        </span>
      </div>
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_6 pr_20">
              <div
                :class="['form_row', { has_error: errorFor('vendor_name') }]"
              >
                <label class="required">Vendor name</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="license.vendor_name"
                  />
                  <v-errors :errors="errorFor('vendor_name')"></v-errors>
                </div>
              </div>
              <div
                :class="['form_row', { has_error: errorFor('provider_name') }]"
              >
                <label class="required">Provider name</label>
                <div class="form_input">
                  <input
                    type="text"
                    class="form_global"
                    v-model="license.provider_name"
                  />
                  <v-errors :errors="errorFor('provider_name')"></v-errors>
                </div>
              </div>

              <div
                :class="['form_row', { has_error: errorFor('service_name') }]"
              >
                <label class="required">Service name</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="license.service_name"
                  />
                  <v-errors :errors="errorFor('service_name')"></v-errors>
                </div>
              </div>

              <div :class="['form_row', { has_error: errorFor('license') }]">
                <label class="required">License</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="license.license"
                  />
                  <v-errors :errors="errorFor('license')"></v-errors>
                </div>
              </div>
              <div
                :class="['form_row', { has_error: errorFor('register_date') }]"
              >
                <label class="required">Register date</label>
                <div class="form_input">
                  <date-picker
                    v-model:input="license.register_date"
                  ></date-picker>
                  <v-errors :errors="errorFor('register_date')"></v-errors>
                </div>
              </div>
              <div
                :class="['form_row', { has_error: errorFor('expire_date') }]"
              >
                <label class="required">Expire date</label>
                <div class="form_input">
                  <date-picker
                    v-model:input="license.expire_date"
                  ></date-picker>
                  <v-errors :errors="errorFor('expire_date')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', { has_error: errorFor('memo') }]">
                <label>Memo</label>
                <div class="form_inline">
                  <text-editor
                    v-model:text="license['memo']"
                    :id="'memo'"
                  ></text-editor>
                  <v-errors :errors="errorFor('memo')"></v-errors>
                </div>
              </div>
            </div>
            <div class="col_6 pl_20">
              <div
                :class="['form_row', { has_error: errorFor('license_remain') }]"
              >
                <label class="">License remain</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="license.license_remain"
                  />
                  <v-errors :errors="errorFor('license_remain')"></v-errors>
                </div>
              </div>
              <div
                :class="['form_row', { has_error: errorFor('company_name') }]"
              >
                <label class="required">Company</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="license.company_name"
                  />
                  <v-errors :errors="errorFor('company_name')"></v-errors>
                </div>
              </div>
              <div
                :class="['form_row', { has_error: errorFor('contact_name') }]"
              >
                <label class="required">Contact</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="license.contact_name"
                  />
                  <v-errors :errors="errorFor('contact_name')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', { has_error: errorFor('number') }]">
                <label class="">Number</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="license.number"
                  />
                  <v-errors :errors="errorFor('number')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', { has_error: errorFor('email') }]">
                <label class="required">Email</label>
                <div class="form_inline">
                  <input
                    type="email"
                    class="form_global"
                    v-model="license.email"
                  />
                  <v-errors :errors="errorFor('email')"></v-errors>
                </div>
              </div>
              <div
                :class="['form_row', { has_error: errorFor('license_count') }]"
              >
                <label class="">License count</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="license.license_count"
                  />
                  <v-errors :errors="errorFor('license_count')"></v-errors>
                </div>
              </div>
              <div class="form_row">
                <label></label>
                <div class="form_inline">
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="update"
                    v-if="$route.params.id"
                  >
                    Update
                  </button>
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="submit"
                    v-else
                  >
                    Save
                  </button>
                  <router-link
                    v-if="$route.params.id"
                    :to="{ name: 'licenses' }"
                    class="btn btn_transparent has_border_radius ml_10"
                    >Cancel</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderMaskComponent from '@/components/LoaderMaskComponent.vue';
import TextEditor from '@/components/shared/TextEditor';
import DatePicker from '@/components/shared/DatePicker';
export default {
  name: 'license-form',
  components: { LoaderMaskComponent, TextEditor, DatePicker },
  data() {
    return {
      lyLoading: false,
      license: {
        vendor_name: '',
        provider_name: '',
        service_name: '',
        license: '',
        register_date: '',
        expire_date: '',
        license_remain: '',
        company_name: '',
        contact_name: '',
        number: '',
        email: '',
        license_count: '',
        memo: '',
      },
    };
  },
  created() {
    if (this.$route.params.id) {
      this.loadData(this.$route.params.id);
    }
  },
  methods: {
    loadData(licenseId) {
      this.lyLoading = true;
      this.axios
        .get('/licenses/' + licenseId)
        .then((response) => {
          this.license = response.data.data;
        })
        .catch(() => {
          this.showFailMsg('No license exists!');
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      Object.keys(this.license).forEach((key) => {
        formData.append(key, this.license[key] ? this.license[key] : '');
      });

      this.axios
        .post('/licenses', formData)
        .then(() => {
          this.resetForm();
          this.showSuccessMsg('License Created Successfully!');
          this.$router.push({ name: 'licenses' });
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },

    update() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      formData.append('_method', 'PATCH');

      Object.keys(this.license).forEach((key) => {
        formData.append(key, this.license[key] ? this.license[key] : '');
      });

      this.axios
        .post('/licenses/' + this.$route.params.id, formData)
        .then(() => {
          this.showSuccessMsg('License Update Successfully!');
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    resetForm() {
      this.license = {
        vendor_name: '',
        provider_name: '',
        service_name: '',
        license: '',
        register_date: '',
        expire_date: '',
        license_remain: '',
        company_name: '',
        contact_name: '',
        number: '',
        email: '',
        license_count: '',
        memo: '',
      };
    },
  },
};
</script>
<style scoped>
.create_item_tab button {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.btn_back {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.font_italic {
  position: relative;
  display: block;
  left: 120px;
  padding-top: 5px;
}
</style>
